import { render, staticRenderFns } from "./own-space.vue?vue&type=template&id=59c76878&scoped=true&"
import script from "./own-space.vue?vue&type=script&lang=js&"
export * from "./own-space.vue?vue&type=script&lang=js&"
import style0 from "./own-space.vue?vue&type=style&index=0&lang=less&"
import style1 from "./own-space.vue?vue&type=style&index=1&id=59c76878&scoped=true&lang=css&"
import style2 from "./own-space.vue?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59c76878",
  null
  
)

component.options.__file = "own-space.vue"
export default component.exports